"use strict";

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectDestructuringEmpty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectDestructuringEmpty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var payment_1 = __importDefault(require("payment"));

var expr_eval_1 = require("expr-eval");

var seamless_immutable_1 = require("seamless-immutable");

var regularExpressions_1 = require("./constants/regularExpressions");

var files_1 = require("./constants/files");

var normalize_1 = require("./normalize");

var creditCard_1 = require("./creditCard");

var defaultMessages_1 = require("./constants/defaultMessages");

var object_1 = require("./object");

var array_1 = require("./array");

var number_1 = require("./number");

var validateLetterAndNumberRequired = function validateLetterAndNumberRequired(str) {
  if (str.search(/\d/) === -1) {
    return false;
  }

  if (str.search(/[a-zA-ZñÑ]/) === -1) {
    return false;
  }

  if (!(str.search(/[+`ç´*]/) === -1)) {
    return false;
  }

  return true;
};

exports.validDateCreditCard = function (errorMessage) {
  return function (val) {
    return moment_1.default(val, 'MM/YY').format('YY-MM') === 'Invalid date' ? errorMessage : undefined;
  };
};

exports.validDate = function (errorMessage) {
  return function (val) {
    return moment_1.default(val, 'DD/MM/YYYY').format('YYYY-MM-DD') === 'Invalid date' ? errorMessage : undefined;
  };
};

exports.meetCuitRequirements = function (cuit) {
  var digits = normalize_1.onlyNumbers(cuit);
  var splittedDigits = digits.split('');
  var lastDigit = parseInt(splittedDigits.pop() || '', 10);
  var accum = 0;

  for (var i = 0; i < splittedDigits.length; i += 1) {
    accum += parseInt(splittedDigits[9 - i], 10) * (2 + i % 6);
  }

  var requiredDigit = 11 - accum % 11;
  if (requiredDigit === 11) requiredDigit = 0;
  return lastDigit === requiredDigit;
};

exports.required = function (errorMessage) {
  return function (val) {
    if (!val) return errorMessage;
    if (typeof val === 'object' && object_1.objectIsEmpty(val)) return errorMessage;
    if (Array.isArray(val) && array_1.isEmpty(val)) return errorMessage;
    return undefined;
  };
};

exports.validateMinLength = function (val, min) {
  return val && val.length >= min;
};

exports.minLength = function (min, errorMessage) {
  return function (val) {
    return val && !exports.validateMinLength(val, min) ? errorMessage : undefined;
  };
};

exports.validateMaxLength = function (val, max) {
  return val && val.length <= max;
};

exports.maxLength = function (max, errorMessage) {
  return function (val) {
    return val && !exports.validateMaxLength(val, max) ? errorMessage : undefined;
  };
};

exports.validateEquals = function (val, length) {
  return val && val.length === length;
};

exports.lengthEquals = function (length, errorMessage, onlyNumbers) {
  return function (val) {
    return val && !exports.validateEquals(onlyNumbers ? normalize_1.onlyNumbers(val) : val, length) ? errorMessage : undefined;
  };
};

exports.cuitValidate = function (string, errorMessage) {
  return function (val) {
    return val && val[0] !== string ? errorMessage : undefined;
  };
};

exports.phoneLength = function (length, errorMessage) {
  return function (val) {
    var value = val && val.replace(/[-]/, '');
    return value && value.length !== length ? errorMessage : undefined;
  };
};

exports.pattern = function (exp, errorMessage) {
  return function (val) {
    return val && !exp.test(val) ? errorMessage : undefined;
  };
};

exports.email = function (errorMessage) {
  return exports.pattern(regularExpressions_1.emailRegex, errorMessage);
};

exports.numericalFourDigits = function (errorMessage) {
  return exports.pattern(regularExpressions_1.numericalFourDigitsRegex, errorMessage);
};

exports.numericalTenDigits = function (errorMessage) {
  return exports.pattern(regularExpressions_1.numericalTenDigitsRegex, errorMessage);
};

exports.lettersAndSpaces = function (errorMessage) {
  return exports.pattern(regularExpressions_1.lettersAndSpacesRegex, errorMessage);
};

exports.atLeastOneNumber = function (errorMessage) {
  return exports.pattern(regularExpressions_1.atLeastOneNumberRegex, errorMessage);
};

exports.atLeastOneLowerCase = function (errorMessage) {
  return exports.pattern(regularExpressions_1.atLeastOneLowerCaseRegex, errorMessage);
};

exports.atLeastOneUpperCase = function (errorMessage) {
  return exports.pattern(regularExpressions_1.atLeastOneUpperCaseRegex, errorMessage);
};

exports.cuitFormat = function (errorMessage) {
  return function (val) {
    return exports.validateMinLength(val, 11) && exports.meetCuitRequirements(val) ? undefined : errorMessage;
  };
};

exports.maxDate = function (maxDate, errorMessage) {
  return function (val) {
    if (!val) return;
    var dateToValidate = moment_1.default(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return moment_1.default(dateToValidate).isSameOrBefore(moment_1.default(maxDate, 'DD/MM/YYYY').format('YYYY-MM-DD')) ? undefined : errorMessage;
  };
};

exports.minDate = function (minDate, errorMessage) {
  return function (val) {
    if (!val) return;
    var dateToValidate = moment_1.default(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return moment_1.default(dateToValidate).isSameOrAfter(moment_1.default(minDate, 'DD/MM/YYYY').format('YYYY-MM-DD')) ? undefined : errorMessage;
  };
};

exports.dateIsInRange = function (lowBound, topBound, errorMessage) {
  return function (val) {
    return exports.minDate(lowBound, errorMessage)(val) || exports.maxDate(topBound, errorMessage)(val);
  };
};

exports.maxNum = function (max, errorMessage) {
  return function (value) {
    return value && !(value <= max) ? errorMessage : undefined;
  };
};

exports.minYear = function (year, errorMessage) {
  return function (value) {
    return value && !(value >= year) ? errorMessage : undefined;
  };
};

exports.letterAndNumberRequired = function (errorMessage) {
  return function (val) {
    return validateLetterAndNumberRequired(val) ? undefined : errorMessage;
  };
};

exports.genKeyMap = function (fields, idOrKey) {
  var keyMap = {};
  fields.forEach(function (field) {
    var index = "".concat(field.key, "_").concat(field.order);
    keyMap[index] = "".concat(idOrKey).concat(field.id);
  });
  return keyMap;
};

var replaceKeys = function replaceKeys(map) {
  return function (str) {
    return str.replace(/\$([a-zA-Z\d-_\.]+_\d+)\b/g, function (_ref, key) {
      _objectDestructuringEmpty(_ref);

      return map[key];
    });
  };
};

var keyToValue = function keyToValue(expr, allValues, idOrKey) {
  return expr.replace(idOrKey === 'id' ? /id\d+\b/g : /key\d+\b/g, function (match) {
    return allValues[match];
  });
};

exports.logicValidation = function (keyMap, logicEvaluation, errorMessage, idOrKey) {
  return function (_, allValues) {
    var expression = replaceKeys(keyMap)(logicEvaluation);

    try {
      var expr = keyToValue(expression, allValues, idOrKey);
      return expr_eval_1.Parser.evaluate(expr) ? undefined : errorMessage;
    } catch (err) {
      return undefined;
    }
  };
};

var validatePasswordStrength = function validatePasswordStrength(errorMessage) {
  var regexs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : regularExpressions_1.passwordWithMultipleGroups;
  var minRequiredValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  return function (value) {
    return regexs.map(function (regex) {
      return regex.test(value) ? 1 : 0;
    }).reduce(function (a, b) {
      return a + b;
    }, 0) >= minRequiredValidations ? undefined : errorMessage;
  };
};

exports.passwordValidations = function (passMinLength, passMaxLength, requireNumberLetter, requireMultipleGroups, errorMessages, regexs, minRequiredValidations) {
  var validate = [exports.required(seamless_immutable_1.getIn(errorMessages, ['passwordRequired'], defaultMessages_1.DefaultMessages.passwordRequired))];

  if (passMinLength === passMaxLength) {
    validate.push(exports.lengthEquals(passMinLength, seamless_immutable_1.getIn(errorMessages, ['passwordExactLength'], defaultMessages_1.DefaultMessages.passwordExactLength)));
  } else {
    validate.push(exports.minLength(passMinLength, seamless_immutable_1.getIn(errorMessages, ['passwordMinLength'], defaultMessages_1.DefaultMessages.passwordMinLength)));
    validate.push(exports.maxLength(passMaxLength, seamless_immutable_1.getIn(errorMessages, ['passwordMaxLength'], defaultMessages_1.DefaultMessages.passwordMaxLength)));
  }

  if (requireNumberLetter) validate.push(exports.letterAndNumberRequired(seamless_immutable_1.getIn(errorMessages, ['passwordRequireLetterAndNumber'], defaultMessages_1.DefaultMessages.passwordRequireLetterAndNumber)));
  if (requireMultipleGroups) validate.push(validatePasswordStrength(seamless_immutable_1.getIn(errorMessages, ['passwordStrength'], defaultMessages_1.DefaultMessages.passwordStrength), regexs, minRequiredValidations));
  return validate;
};

exports.validateDependantField = function (dependantFieldName, errorMessage) {
  return function (val, allValues) {
    return val || allValues[dependantFieldName] ? undefined : errorMessage;
  };
};

exports.validateRequiredOnField = function (requiredOnFieldName, errorMessage) {
  return function (val, allValues) {
    return allValues[requiredOnFieldName] && !val ? errorMessage : undefined;
  };
};

exports.validateInvalidBins = function (invalidBins, errorMessage) {
  return function (value) {
    var bin = value && value.substring(0, 6);
    return invalidBins.includes(bin) && errorMessage;
  };
};

exports.validateCreditCard = function (errorMessage) {
  return function (value) {
    var isValid = payment_1.default.fns.validateCardNumber(value);
    return !isValid && errorMessage;
  };
};

exports.validatePhoneWithChildKeys = function (errorMessage) {
  return function (value) {
    if (value) {
      var valuesArray = Object.values(value);
      return array_1.isEmpty(valuesArray) || !valuesArray[0] || !valuesArray[1] || "".concat(valuesArray[0]).concat(valuesArray[1]).length !== 10 ? errorMessage : undefined;
    }

    return undefined;
  };
};

exports.validateSketch = function (errorMessages, configuration) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var messages = {};
    var child_keys = configuration.child_keys || {};
    var optionalKeys = ['leftNeighbor', 'rightNeighbor'];
    Object.keys(child_keys).forEach(function (key) {
      var currentKey = child_keys[key];

      if (!optionalKeys.includes(key) && array_1.isEmpty(value[currentKey])) {
        messages[currentKey] = seamless_immutable_1.getIn(errorMessages, [key], defaultMessages_1.DefaultMessages.sketchRequired);
      }
    });
    var validations = JSON.stringify(messages);
    return Object.keys(messages).length > 0 && validations;
  };
};

exports.validateAnimatedCreditCard = function (errorMessages, childKeys, invalidBins) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var messages = {};

    var _childKeys = _slicedToArray(childKeys, 5),
        cardNumberKey = _childKeys[0],
        holderNameKey = _childKeys[1],
        securityCodeKey = _childKeys[2],
        expMonthKey = _childKeys[3],
        expYearKey = _childKeys[4];

    var expires = value[expYearKey] && value[expMonthKey] && "".concat(value[expYearKey]).concat(value[expMonthKey]);

    if (!value[cardNumberKey] || value[cardNumberKey].length === 0) {
      messages.cardNumber = seamless_immutable_1.getIn(errorMessages, ['cardNumberRequired'], defaultMessages_1.DefaultMessages.cardNumberRequired);
    } else {
      var payment = {};
      payment = payment_1.default;
      creditCard_1.fixCreditCardsPatterns(payment);
      var issuer = payment.fns.cardType(value[cardNumberKey]);
      var isValid = issuer === 'maestro' || payment.fns.validateCardNumber(value[cardNumberKey]);
      if (!isValid) messages.cardNumber = seamless_immutable_1.getIn(errorMessages, ['invalidCardNumber'], defaultMessages_1.DefaultMessages.invalidCardNumber);
    }

    if (invalidBins) {
      var errorMessage = seamless_immutable_1.getIn(errorMessages, ['disabledCardNumber'], defaultMessages_1.DefaultMessages.invalidCardNumber);
      var isInvalid = exports.validateInvalidBins(invalidBins, errorMessage)(value[cardNumberKey]);

      if (isInvalid) {
        messages.cardNumber = errorMessage;
      }
    }

    if (!value[holderNameKey] || value[holderNameKey].length === 0) messages.holderName = seamless_immutable_1.getIn(errorMessages, ['holderNameRequired'], defaultMessages_1.DefaultMessages.holderNameRequired);

    if (!value[expMonthKey] || !value[expYearKey] || value[expMonthKey].length === 0 || value[expYearKey].length === 0) {
      messages.expires = seamless_immutable_1.getIn(errorMessages, ['expiresRequired'], defaultMessages_1.DefaultMessages.expiresRequired);
    } else {
      var creditCardDate = moment_1.default(expires, 'YYYYMM');
      var today = moment_1.default();
      var isValidDate = creditCardDate.isValid() && today < creditCardDate.add(1, 'months') && expires.length === 6;
      if (!isValidDate) messages.expires = seamless_immutable_1.getIn(errorMessages, ['invalidExpires'], defaultMessages_1.DefaultMessages.invalidExpires);
    }

    if (!value[securityCodeKey] || value[securityCodeKey].length === 0) messages.securityCode = seamless_immutable_1.getIn(errorMessages, ['securityCodeRequired'], defaultMessages_1.DefaultMessages.securityCodeRequired);
    var validations = JSON.stringify(messages);
    return Object.keys(messages).length > 0 && validations;
  };
};

var validateNoInitialZero = function validateNoInitialZero(value) {
  return value && value.substring(0, 1) !== '0';
};

exports.validateDocumentNumber = function (errorMessage) {
  return function (value) {
    return !exports.validateMinLength(value, 7) ? errorMessage : !exports.validateMaxLength(value, 8) ? errorMessage : !validateNoInitialZero(value) ? errorMessage : undefined;
  };
};

var checkSignature = function checkSignature(fileSignature, admitedTypes, fileType) {
  var validateAdmitedType = function validateAdmitedType() {
    return admitedTypes.some(function (admitedType) {
      return files_1.inputFiles[admitedType].validType.includes(fileType);
    });
  };

  var validateSignature = function validateSignature() {
    return admitedTypes.some(function (admitedType) {
      return files_1.inputFiles[admitedType].signatures.includes(fileSignature.toUpperCase());
    });
  };

  if (fileSignature && fileType && fileType.length > 1 && validateAdmitedType()) {
    return validateSignature();
  }

  return false;
};

var documentValidationDefaultMessages = {
  dniFormat: 'El DNI ingresado no tiene un formato válido',
  cuitFormat: 'El CUIT ingresado no tiene un formato válido',
  otherFormat: 'El número de documento ingresado no tiene un formato válido',
  cipFormat: 'El CI Provincial ingresado no tiene un formato válido',
  cdiFormat: 'La Cédula de identidad ingresada no tiene un formato válido',
  leFormat: 'La Libreta de enrolamiento ingresada no tiene un formato válido',
  passportFormat: 'El Pasaporte ingresado no tiene un formato válido',
  lcFormat: 'La Libreta cívica ingresada no tiene un formato válido',
  default: 'El DNI ingresado no tiene un formato válido'
};

exports.documentValidation = function (messages, docTypeId) {
  return function (value, allValues) {
    var type = allValues.docType || allValues.document_type || allValues["id".concat(docTypeId)];

    switch (type) {
      case 'dni':
        return exports.validateMinLength(value, 6) && exports.validateMaxLength(value, 8) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'cuit':
        return exports.validateEquals(value, 11) && exports.meetCuitRequirements(value) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'other':
        return exports.validateMinLength(value, 5) && exports.validateMaxLength(value, 11) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'provincial_ci':
        return exports.validateMinLength(value, 7) && exports.validateMaxLength(value, 8) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'identity_card':
        return exports.validateMinLength(value, 7) && exports.validateMaxLength(value, 8) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'enlistment_book':
        return exports.validateMinLength(value, 6) && exports.validateMaxLength(value, 8) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'cert_of_document_in_proccess':
        return exports.validateMinLength(value, 5) && exports.validateMaxLength(value, 11) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'passport':
        return exports.validateMinLength(value, 7) && exports.validateMaxLength(value, 9) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      case 'civic_notebook':
        return exports.validateMinLength(value, 6) && exports.validateMaxLength(value, 8) ? undefined : messages && messages[type] || documentValidationDefaultMessages[type];

      default:
        return value ? undefined : messages && messages.default || documentValidationDefaultMessages.default;
    }
  };
};

function readFileAsync(file, admitedTypes, fileType) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function (e) {
      var fileSignature = '';
      var bytes = new Uint8Array(e.target.result);

      for (var i = 0; i < bytes.length; i += 1) {
        var byte = bytes[i];
        fileSignature += (byte < 10 ? '0' : '') + byte.toString(16);
      }

      var result = checkSignature(fileSignature, admitedTypes, fileType);
      resolve(result);
    };

    reader.onerror = reject;
    reader.readAsArrayBuffer(file.slice(0, 4));
  });
}

exports.fileSignatureValidation = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, admitedTypes, fileType) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return readFileAsync(file, admitedTypes, fileType);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", !!result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fileSizeValidation = function (file, maxFileSize) {
  return file.size <= maxFileSize;
};

exports.sameValue = function (key, errorMessage) {
  return function (value, allValues) {
    return value === allValues[key] ? undefined : errorMessage;
  };
};

exports.differentValue = function (key, errorMessage) {
  return function (value, allValues) {
    return value && allValues[key] && value !== allValues[key] ? undefined : errorMessage;
  };
};

exports.validateOnlyLettersAndNumbers = function (errorMessage) {
  return function (value) {
    return /[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]/g.test(value) ? errorMessage : undefined;
  };
};

exports.validateBetweenValues = function (min, max, errorMessage, hasSign) {
  return function (val) {
    var value = val;
    if (hasSign) value = val.substring(1);
    return number_1.between(min, max, parseInt(value, 10)) ? undefined : errorMessage;
  };
};

var VALIDATE_UTILS = {
  atLeastOneNumber: exports.atLeastOneNumber,
  atLeastOneLowerCase: exports.atLeastOneLowerCase,
  atLeastOneUpperCase: exports.atLeastOneUpperCase,
  validDateCreditCard: exports.validDateCreditCard,
  validDate: exports.validDate,
  meetCuitRequirements: exports.meetCuitRequirements,
  required: exports.required,
  validateMinLength: exports.validateMinLength,
  minLength: exports.minLength,
  validateMaxLength: exports.validateMaxLength,
  maxLength: exports.maxLength,
  validateEquals: exports.validateEquals,
  lengthEquals: exports.lengthEquals,
  cuitValidate: exports.cuitValidate,
  logicValidation: exports.logicValidation,
  genKeyMap: exports.genKeyMap,
  phoneLength: exports.phoneLength,
  pattern: exports.pattern,
  email: exports.email,
  numericalFourDigits: exports.numericalFourDigits,
  numericalTenDigits: exports.numericalTenDigits,
  lettersAndSpaces: exports.lettersAndSpaces,
  cuitFormat: exports.cuitFormat,
  maxDate: exports.maxDate,
  minDate: exports.minDate,
  dateIsInRange: exports.dateIsInRange,
  maxNum: exports.maxNum,
  minYear: exports.minYear,
  letterAndNumberRequired: exports.letterAndNumberRequired,
  passwordValidations: exports.passwordValidations,
  validateDependantField: exports.validateDependantField,
  validateRequiredOnField: exports.validateRequiredOnField,
  validateInvalidBins: exports.validateInvalidBins,
  validateCreditCard: exports.validateCreditCard,
  validateAnimatedCreditCard: exports.validateAnimatedCreditCard,
  validateSketch: exports.validateSketch,
  validateDocumentNumber: exports.validateDocumentNumber,
  fileSignatureValidation: exports.fileSignatureValidation,
  fileSizeValidation: exports.fileSizeValidation,
  sameValue: exports.sameValue,
  differentValue: exports.differentValue,
  documentValidation: exports.documentValidation,
  validatePhoneWithChildKeys: exports.validatePhoneWithChildKeys,
  emailRegex: regularExpressions_1.emailRegex,
  validateOnlyLettersAndNumbers: exports.validateOnlyLettersAndNumbers,
  validateBetweenValues: exports.validateBetweenValues
};
exports.default = VALIDATE_UTILS;